import React from 'react';
import { ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Comparison() {
  return <section className="bg-cream-50 px-5 py-10 sm:py-16" data-id="element-35" data-mp="1l75mv8w3o05f">
      <div className="mx-auto max-w-5xl" data-id="element-36" data-mp="1l5kthmliun95">
        <SectionHeading eyebrow="La realidad" title="¿Cuánto te cuesta NO resolverlo?" data-id="element-37" data-mp="1pz5vrqu5e3e5" />

        <div className="mt-5 flex items-center justify-center gap-3 text-[0.6rem] font-bold uppercase tracking-[0.12em] sm:mt-8 sm:text-[0.68rem]" data-id="element-38" data-mp="1uy0bul0qdduk">
          <span className="flex items-center gap-1.5 text-clay" data-id="element-39" data-mp="1zyelu8lw6xv8">
            <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-40" data-mp="23yyfh279bjcm" /> Sin el método
          </span>
          <ArrowRightIcon className="h-3 w-3 text-forest-900/25" aria-hidden="true" data-id="element-41" data-mp="28x8btg4pwpzt" />
          <span className="flex items-center gap-1.5 text-forest-700" data-id="element-42" data-mp="9kdzh2tvsbzk">
            <CheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-43" data-mp="9m8ksi92e646" /> Con el método
          </span>
        </div>

        <ul className="mt-3 grid gap-1.5 sm:mt-5 sm:grid-cols-2 sm:gap-2" data-id="element-44" data-mp="1m0peuiscdtip">
          {comparisonRows.map(row => <li key={row.with} className="grid grid-cols-[1fr_auto_1fr] items-center gap-2 rounded-lg bg-cream-100 px-2.5 py-2 ring-1 ring-inset ring-forest-900/[0.06] transition-colors duration-150 ease-out hover:bg-cream-200/60 sm:gap-3 sm:px-3.5 sm:py-2.5" data-id="element-45" data-mp="1h9h51ln3o650">
              <span className="text-[0.7rem] leading-tight text-forest-900/50 line-through decoration-clay/40 sm:text-[0.78rem]" data-id="element-46" data-mp="24zuvx8ty7yy0">
                {row.without}
              </span>
              <ArrowRightIcon className="h-3.5 w-3.5 shrink-0 text-gold-500" aria-hidden="true" data-id="element-47" data-mp="1vyn0cyithc7m" />
              <span className="text-[0.72rem] font-semibold leading-tight text-forest-900 sm:text-[0.8rem]" data-id="element-48" data-mp="1r028pnhms0us">
                {row.with}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}